const onlyUnique = (value, index, array) => {
  return array.indexOf(value) === index;
};

export { onlyUnique };
